/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs */

const en_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help your members`)
};

const de_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilf deinen Mitgliedern`)
};

const es_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda a tus miembros`)
};

const fr_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aidez vos membres`)
};

const nl_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help je leden`)
};

const it_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiuta i tuoi membri`)
};

const pt_br2_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajude seus membros`)
};

const pl_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomóż swoim członkom`)
};

const hu_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segítsen tagjainak`)
};

const ro_admin_dashboard_empty_state_help_desk_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajutati-va membrii`)
};

/**
* | output |
* | --- |
* | "Help your members" |
*
* @param {Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_help_desk_description = /** @type {((inputs?: Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Help_Desk_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_help_desk_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_help_desk_description(inputs)
	return ro_admin_dashboard_empty_state_help_desk_description(inputs)
});
export { admin_dashboard_empty_state_help_desk_description as "admin.dashboard.empty_state.help_desk.description" }